// src/i18n/es/options.ts
// «Opciones del hotel» y «Opciones de Roommatik» — mockup 13, tabs 2 and 3 of
// the existing Opciones page (Administración → Opciones, `AdminOptionsPage`).
// «Mis preferencias» (tab 1) stays in `preferences.ts` (wave 1).
export const options = {
  toast: {
    saved: 'Guardado correctamente',
    saveError: 'No se ha podido guardar. Inténtelo de nuevo.',
  },

  hotel: {
    tabLabel: 'Opciones del hotel',
    selectHotel: 'Instalación',
    sections: {
      stuck: 'Umbrales de bloqueo (minutos)',
      general: 'General',
      wall: 'Pantalla de pared',
      devices: 'Dispositivos',
    },
    fields: {
      stuckS: 'Búsqueda de la reserva (S)',
      stuckR: 'Selección de habitación (R)',
      stuckI: 'Identificación (I)',
      stuckF: 'Firma (F)',
      stuckU: 'Extras (U)',
      stuckP: 'Pago (P)',
      stuckK: 'Entrega de llave (K)',
      onlineThresholdsDoubled: 'Duplicar los umbrales para el pre-check-in online',
      chargesOnline: 'La instalación cobra en el pre-check-in online',
      durationBuckets: 'Franjas de duración',
      wallTheme: 'Tema de la pantalla',
      wallContent: 'Contenido de la pantalla',
      wallFooterCounters: 'Mostrar contadores en el pie',
      showAirLobbyStaff: 'Mostrar personal en Air Lobby',
      silentDeviceHours: 'Horas sin actividad antes de avisar',
      deviceNames: 'Nombres de dispositivo',
    },
    durationBucketsOptions: {
      standard: 'Estándar',
      fastKiosk: 'Kiosco rápido',
    },
    wallThemeOptions: {
      dark: 'Oscuro',
      light: 'Claro',
    },
    wallContentOptions: {
      full: 'Completo',
      liveOnly: 'Solo en directo',
    },
    applyToGroup: 'Aplicar a todos los hoteles del grupo',
    applyToGroupConfirm: '¿Aplicar esta configuración a todos los hoteles del grupo? Se sobrescribirán sus opciones actuales.',
    help: {
      title: 'Opciones del hotel',
      description: 'Los umbrales de bloqueo, la pantalla de pared y otros parámetros propios de esta instalación.',
      features: {
        thresholds: 'Cada sección del proceso (idioma, datos, identificación…) tiene su propio umbral de minutos antes de marcarse como bloqueada.',
        applyToGroup: 'Un administrador de grupo puede copiar esta configuración a todos los hoteles del grupo de una vez.',
      },
    },
  },

  roommatik: {
    tabLabel: 'Opciones de Roommatik',
    selectGroup: 'Grupo',
    fields: {
      nameRetentionDays: 'Días de conservación del nombre del huésped',
      viewerCanExport: 'El rol Visor puede exportar',
    },
    help: {
      title: 'Opciones de Roommatik',
      description: 'Parámetros de todo el grupo: cuánto se conserva el nombre del huésped y si el rol Visor puede exportar.',
      features: {
        retention: 'Pasado este número de días desde la salida, el nombre del huésped se borra de las reservas.',
      },
    },
  },
};

export default options;
